import React, { useEffect, useState } from "react";
import { Button, Input, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { getEligibleManagersApi, setReportingManagerApi } from "../../../apiServices/adminWork.services";

const AssignManager = ({ selectedUser, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [managers, setManagers] = useState([]);
  const [managerId, setManagerId] = useState("");

  const fetchManagers = async () => {
    try {
      const res = await getEligibleManagersApi(selectedUser._id);
      setManagers(res?.data?.users || []);
    } catch (err) {
      toast.error("Failed to load managers");
    }
  };

  useEffect(() => {
    fetchManagers();
  }, []);

  const handleSubmit = async () => {
    if (!managerId) return toast.error("Select manager");

    try {
      setLoading(true);

      await setReportingManagerApi(selectedUser._id, {
        managerId,
      });

      toast.success("Manager assigned");
      onSuccess && onSuccess();
    } catch (err) {
      toast.error(err?.error || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <label className="mb-2">Select Reporting Manager</label>

      <Input
        type="select"
        value={managerId}
        onChange={(e) => setManagerId(e.target.value)}
      >
        <option value="">Select</option>
        {managers
          .filter((m) => m._id !== selectedUser._id)
          .map((m) => (
             <option key={m._id} value={m._id}>
                {`${m.firstName} ${m.lastName}${
                  m.designationId?.title ? ` - ${m.designationId.title}` : ""
                }`}
             </option>
          ))}
      </Input>

      <div className="text-end mt-3">
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Assign"}
        </Button>
      </div>
    </div>
  );
};

export default AssignManager;